import { motion } from "framer-motion";
import { ShieldCheck, Coins, Users } from "lucide-react";

const PILLS = [
  {
    icon: ShieldCheck,
    title: "Licensed engineers",
    note: "EPRA-registered and NCA-licensed. Every install signed off and documented.",
    accent: "blue",
  },
  {
    icon: Coins,
    title: "Fixed-price quotes",
    note: "Clear scope, fixed budget, no surprises after the site visit.",
    accent: "white",
  },
  {
    icon: Users,
    title: "Single accountable team",
    note: "One point of contact from design through commissioning and beyond.",
    accent: "crimson",
  },
];

const accentMap = {
  blue: "var(--accent-blue)",
  white: "var(--text)",
  crimson: "var(--accent-crimson-hover)",
};

const WhyTafra = () => {
  return (
    <section
      id="why"
      className="relative py-16 sm:py-20 overflow-hidden"
      style={{ background: "var(--bg)" }}
      data-testid="why-section"
      aria-label="Why choose TAFRA Energy"
    >
      <div className="absolute inset-0 energy-grid-bg opacity-[0.12] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6">
          {PILLS.map((p, i) => {
            const Icon = p.icon;
            const acc = accentMap[p.accent];
            return (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                data-testid={`why-pill-${i}`}
                className="group relative p-6 lg:p-7 btn-sharp overflow-hidden"
                style={{
                  background: "var(--surface)",
                  border: "1px solid var(--border)",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.borderColor = acc)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.borderColor = "var(--border)")
                }
              >
                <span
                  aria-hidden
                  className="absolute -top-px left-6 h-px w-12"
                  style={{
                    background: `linear-gradient(90deg, transparent, ${acc}, transparent)`,
                  }}
                />
                <div className="flex items-start gap-4">
                  <span
                    className="shrink-0 w-10 h-10 flex items-center justify-center btn-sharp"
                    style={{
                      border: `1px solid ${acc}`,
                      color: acc,
                      background: "var(--bg-soft)",
                    }}
                  >
                    <Icon className="w-4 h-4" strokeWidth={1.6} />
                  </span>
                  <div>
                    <h3
                      className="font-display text-lg font-medium leading-snug"
                      style={{ color: "var(--text)" }}
                    >
                      {p.title}
                    </h3>
                    <p
                      className="mt-2 text-sm leading-relaxed"
                      style={{ color: "var(--text-muted)" }}
                    >
                      {p.note}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyTafra;
